module.exports = __webpack_public_path__ + "static/media/GT-Standard-L-Extended-Bold.140f2aed.otf";